/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the daily grandfathered-plan sweep: subscribers on archived plan prices are moved to the current plan price at renewal and notified by email. Off when absent — grandfathered subscribers keep their legacy pricing indefinitely.
 * @export
 * @interface GrandfatheredUpdatesModule
 */
export interface GrandfatheredUpdatesModule {
    /**
     * 
     * @type {boolean}
     * @memberof GrandfatheredUpdatesModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the GrandfatheredUpdatesModule interface.
 */
export function instanceOfGrandfatheredUpdatesModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GrandfatheredUpdatesModuleFromJSON(json: any): GrandfatheredUpdatesModule {
    return GrandfatheredUpdatesModuleFromJSONTyped(json, false);
}

export function GrandfatheredUpdatesModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrandfatheredUpdatesModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function GrandfatheredUpdatesModuleToJSON(value?: GrandfatheredUpdatesModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

